var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpNarrow = function SvgArrowUpNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.187 7.813a1.15 1.15 0 0 1 0-1.627l4-4a1.2 1.2 0 0 1 .271-.2 1.1 1.1 0 0 1 .32-.114q.169-.033.338-.017.139.016.266.062.082.027.16.07l.041.023q.124.072.23.176l4 4a1.15 1.15 0 0 1-1.626 1.627L13.492 6.12a.2.2 0 0 0-.342.14V21a1.15 1.15 0 0 1-2.3 0V6.26a.2.2 0 0 0-.342-.14L8.813 7.813a1.15 1.15 0 0 1-1.626 0"
  })));
};
export default SvgArrowUpNarrow;